<div class="container-fluid p-0">
  <div class="row m-0">
    <div class="col-12 p-0">
      <div class="login-card login-dark">
        <div>
          <div>
            <a class="logo">
              <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="looginpage" />
            </a>
          </div>
          <div class="login-main">
            <h4>Reset Your Password</h4>
            <p>A temporary password will be sent to your email address</p>
            <div class="form-group">
              <label class="col-form-label">Email Address</label>
              <input
                data-testid="email"
                class="form-control"
                type="email"
                placeholder="Email"
                [(ngModel)]="email"
                name="email"
              />
            </div>
            <div class="text-end mt-3">
              <button
                class="btn btn-primary btn-block w-100"
                (click)="forgotPassword()"
                data-testid="send-button"
              >
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
